<template>
  <h2 v-if="!connectedAccountId">You need an account with Stripe to start receiving payments</h2>
  <div class="mt-2" v-if="!accountCreatePending && !connectedAccountId">
    <button class="g--button" @click="createAccount">Create my account</button>
  </div>
  <div id="embedded-onboarding-container"/>
  <p v-if="error" class="error">Something went wrong!</p>
  <div v-if="connectedAccountId || accountCreatePending" class="dev-callout">
<!--    <p v-if="connectedAccountId">Your connected account ID is: <code class="bold">{{ connectedAccountId }}</code>-->
<!--    </p>-->
    <p v-if="accountCreatePending">Creating a connected account...</p>
    <p v-if="onboardingExited">The Account Onboarding component has exited</p>
    <connect-embed type="onboarding" v-if="connectedAccountId" :connectedAccountId="connectedAccountId"/>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { loadConnectAndInitialize } from '@stripe/connect-js'
import ConnectEmbed from './ConnectEmbed.vue';

const accountCreatePending = ref(false);
const onboardingExited = ref(false);
const error = ref(false);
const connectedAccountId = ref(null);
const stripeConnectInstance = ref(null);

const props = defineProps({
  userEmail: String,
  connectId: String
});

onMounted(() => {
  console.log('hello');
  if (props.connectId) {
    connectedAccountId.value = props.connectId;
  }
});

const createAccount = () => {
  accountCreatePending.value = true;
  error.value = false;
  let data = {};
  data['email'] = props.userEmail;
  data[csrfTokenName] = csrfTokenValue;
  fetch('/actions/live-yoga-teachers/connect', {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data),
  }).then((response) =>
          response.json().then((json) => {
            accountCreatePending.value = false;
            connectedAccountId.value = json.account;
          })
      )
      .catch((error) => {
        console.error(error);
      });
};
</script>


